<div id="messageModal" [ngClass]="modalClass">
    @if (message) {
        <div class="errorTile modalTile">
            <!-- Schliessen Button -->
            <div class="closeMe" (click)="close()" title="{{txtClose}}"></div>
            <!-- Ueberschrift -->
            <div class="headline">
                {{ message.headline }}
            </div>
            @if (message.details.length > 0) {
                <div class="warning">
                    <div class="warningIconWrapper">
                        <!-- Icons der Warnungen -->
                        <div class="ic"><i class="icon ico-info">&#160;</i></div>
                    </div>
                    <div class="warningMessageWrapper">
                        <!-- Inhalt -->
                        @for (detail of message.details; track detail) {
                            <div>{{ detail }}</div>
                        }
                    </div>
                </div>
            }
            <div class="gridContainer fitGrid">
                <div class="row">
                    <div class="cell grid-100">
                        <button class="btn-orange" data-dismiss="modal" (click)="close()">
                            OK
                        </button>
                    </div>
                </div>
            </div>
        </div>
    }
</div>
